import { Navigate, useLocation } from "react-router-dom";
import type { ChatTurnProps } from "../../types/chat";
import { ScreenStepTurn } from "../ScreenStepTurn";
import { getApplicationScreen } from "./applicationScreen";

export function ApplicationTurn(props: ChatTurnProps) {
  const location = useLocation();
  const screen = getApplicationScreen(props, location.state);

  if (!screen) {
    return <ScreenStepTurn {...props} />;
  }

  return <Navigate to={screen} replace />;
}
